import { lazyLoadMedia } from './utils/lazyload';
import { initSwiper } from './library/swiper';
import { initFancybox } from './library/fancybox';
import { initNotyf } from './library/notification';
import { initializeTabs } from './library/tabs';
import { initTooltip } from './library/typpy';
import { initMarquee } from './library/marquee';
import { modal } from './library/modal';
import { initAccordion } from './library/accordion';
import {anchor} from "./main/anchor";
import {phone} from "./main/phone";
import {menu} from "./main/menu";
/*import 'dragscroll';*/
document.addEventListener('DOMContentLoaded', () => {
    lazyLoadMedia();
    anchor();
    phone();
    menu();
    //initAccordion();
    // initSwiper();
    // initFancybox();
    // initNotyf();
    // initializeTabs();
    // initTooltip();
    // initMarquee();
    modal;
});

